import { useParams } from 'react-router-dom';

import { GoalSetView } from '@/components/goals/goal-set';
import { PageContainer } from '@/components/shell/page-container';

/** Your own goals. */
export function MyGoalsPage() {
  return (
    <PageContainer>
      <GoalSetView employeeId="me" />
    </PageContainer>
  );
}

/** A report's goals, for the manager who sets them. */
export function EmployeeGoalsPage() {
  const { employeeId } = useParams<{ employeeId: string }>();
  return (
    <PageContainer>
      {employeeId ? <GoalSetView employeeId={employeeId} /> : null}
    </PageContainer>
  );
}
